import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { CryptoToken } from 'src/environments/crypto.token';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  constructor() { }


  encryptData(data) {
     return CryptoJS.AES.encrypt(data, CryptoToken.token).toString();
  }

  decryptData(data) {
   let bytes =  CryptoJS.AES.decrypt(data, CryptoToken.token);
   return  bytes.toString(CryptoJS.enc.Utf8);
  }
}

 

